import { toast } from 'react-toastify';
import { useDeleteConfirmation } from '../common';
import useApi from '../../api';
import GenericSelectableTable from '../selectableTable';
import enumChoice from '../../enum';
import InventoryVariantTable from './inventoryVariantTable';

const InventoryTable = ({ products, fetchInventory }: any) => {
    const { handleDelete } = useDeleteConfirmation();
    const api = useApi();

    const bullkActionButtons = [
        {
          label: 'Draft Selected',
          onClick: (selectedItems:any) => {
            const payload = {
                status: enumChoice.publishableStatus.toKV().DRAFT.value,
                product_ids: Array.from(selectedItems),
            }
            api.updateProductStatusBulk(payload).then((response) => {
                fetchInventory();
                toast.success("Product status updated successfully");
            }, (error) => {
                toast.error("Failed to update product status");
            })
          },
        },
    ];

    // Define columns with render functions for custom content
    const columns = [
        { header: "Product", key: "id", render: (item: any) => (
            <div className="flex flex-col space-y-1">
                <p className="text-lg font-semibold text-gray-800">{item.name}</p>
                <p className="text-sm text-gray-500">#{item.id}</p>
            </div>
        )},
        { header: "Variants", key: "status", render: (item: any) => (
            <InventoryVariantTable variants={item.variants} onInventoryUpdate={fetchInventory} />
        )},
    ];

    return (
        <div className="relative overflow-x-auto px-1">
            <GenericSelectableTable columns={columns} data={products?.results || []} />
        </div>
    );
};

export default InventoryTable;
